<script setup>
import dayjs from "@/utils/dayjs.js";

const loadingStore = useLoadingStore();
const messageStore = useMessageStore();

onBeforeMount(() => (document.documentElement.style.opacity = "1"));
</script>
<template>
  <v-app ref="app" full-height>
    <v-snackbar
      v-for="message in messageStore.messages"
      :key="message.id"
      :color="message.type || 'info'"
      :model-value="true"
      location="top right"
      :timeout="message.timeout || 7000"
      class="mt-5"
      @update:model-value="messageStore.remove(message.id)"
    >
      {{ message.key ? $t(message.key, message.params) : message.message }}
    </v-snackbar>
    <v-overlay :model-value="loadingStore.loading" opacity="0.7" z-index="2000" class="justify-center align-center" persistent>
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <router-view />
    <v-footer dark absolute app color="#A6ADB4" class="text-caption text-white pt-2" :height="$vuetify.display.mdAndUp ? '60px' : '220px'">
      <v-container class="pa-3 dense">
        <v-row class="flex-column flex-md-row align-center">
          <v-col cols="12" md="8" class="text-center">
            <img class="mt-2" src="@/assets/logo-white.svg" width="150" :title="$t('common.brand.alvarum')" :alt="$t('common.brand.alvarum')" />
          </v-col>
          <v-col cols="12" md="4">
            <v-row justify="center" class="flex-column flex-md-row flex-md-nowrap text-md-no-wrap align-center ga-1 ga-md-0">
              <a class="text-white" href="https://helpfr.alvarum.com/">{{ $t("common.footer.help") }}</a>
              <a class="pl-md-4 text-white" href="https://backoffice.alvarum.com/">{{ $t("common.footer.charityAccount") }}</a>
              <a class="pl-md-4 text-white" href="https://fr.alvarum.com/cgu">{{ $t("common.footer.termsAndConditions") }}</a>
              <a class="pl-md-4 text-white" href="https://fr.alvarum.com/gdpr">{{ $t("common.footer.privacyPolicy") }}</a>
              <a class="pl-md-4 text-white" href="https://fr.alvarum.com/mentions">{{ $t("common.footer.legalNotice") }}</a>
              <span class="pl-md-4">{{ dayjs().year() }} ©</span>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <router-view name="dialog"></router-view>
  </v-app>
</template>
